export default __webpack_public_path__ + "static/firmbee-com-gcsNOsPEXfs-unsplash-791ff90a68898a643da0da194d6f7715.jpg";